// extracted by mini-css-extract-plugin
export default {"divider":"BLHorizontalLineTitle_divider__Q7dUA"};